import React from 'react';
import { useRouter } from 'next/router';
import { NextPage } from 'next';
import JobSearchPage from '../components/Jobs/JobSearch';
import withApollo from '../lib/apollo';
import profileBySlugEBPQuery
  from '../lib/queries/products/profileBySlugEbpQuery.graphql';
import withQuery from '../lib/withQuery';
import Loader from '../components/Loader';
import Layout from '../components/Layout';

const JobSearchPageWithQuery = withQuery(JobSearchPage);

const CompanyProfilePage = () => {
  const { query: { companySlug } } = useRouter();

  return (
    <JobSearchPageWithQuery
      query={profileBySlugEBPQuery}
      variables={{ slug: companySlug }}
      errorMessage="Error loading jobs"
      loader={<Loader fullScreen />}
      field="profileBySlug"
      notFound={null}
    />
  );
};

CompanyProfilePage.getLayout = (page: NextPage) => (
  <Layout disableNavigation disableFooter layoutMaxWidth="100vw">
    {page}
  </Layout>
);

const CompanyProfilePageWithApollo = withApollo(CompanyProfilePage);

export default CompanyProfilePageWithApollo;
